import { createContext } from "@compono/ui";

type IframeDetection = {
  isInIframe: boolean;
};

const [useIframeDetection, IframeDetectionContext] =
  createContext<IframeDetection>({
    name: "IframeDetection",
  });

const IframeDetectionProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const isInIframe = window.self !== window.top;
  return (
    <IframeDetectionContext.Provider value={{ isInIframe }}>
      {children}
    </IframeDetectionContext.Provider>
  );
};

export { useIframeDetection, IframeDetectionProvider };
